import { render, staticRenderFns } from "./PriceNews.vue?vue&type=template&id=149919eb&"
import script from "./PriceNews.vue?vue&type=script&lang=js&"
export * from "./PriceNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports